'use client';

import clsx from 'clsx';
import { AppLink } from '@/shared/ui/atoms';
import type { SocialLinkProps } from './types';

export default function SocialLink({ href, icon: Icon, label, size = 20, className, classNames }: SocialLinkProps) {
    return (
        <AppLink
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className={clsx(classNames?.root, className)}
            classNames={classNames}
            startIcon={<Icon size={size} />}
        />
    );
}
